import * as React from "react";
import PaymentRestartFinishPage from "../pages/PaymentRestartFinish";

const PaymentMakeRestartContainer = () => {
    return <PaymentRestartFinishPage />;
};

export default PaymentMakeRestartContainer;
